<template>
    <div id="HomeContentItems">
        <div class="itemsTitle">{{title}}</div>
        <div class="itemscontent" >
<!--            <HomeItem v-for="(item, index) in contentItems" :key="index" :data="item" @clickAction="headerTitleClick(index)"></HomeItem>-->
            <div class="carrierButton" @click="headerTitleClick(0)">Carrier Request List</div>
            <div class="cfButton" @click="headerTitleClick(1)">Carrier Response CF Task List</div>

        </div>
    </div>
</template>

<script>
import HomeItem from './HomeItem'

export default {
  name: 'HomeContentItems',
  props: ['title', 'contentItems'],
  components: {
    HomeItem
  },
  data () {
    return {}
  },
  destroyed () {
  },
  created () {
  },
  methods: {
    headerTitleClick (data, index) {
      // console.log(data, index)
      this.$emit('cellClick', data)
    }
  }
}
</script>

<style lang="scss" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #HomeContentItems {
        padding: 0;
        background-color: #fff;

        .itemsTitle {
            width: 100%;
            height: 40px;
            border-bottom: 1px solid #eee;
            text-align: left;
            font-weight: 700;
            font-style: normal;
            font-size: 22px;
            color: rgba(0, 0, 0, 0.847058823529412);
            line-height: 18px;
            padding-left: 20px;
        }

        .itemscontent {
            width: 100%;
            margin-top: 10px;
            padding: 10px;
            display: flex;
            justify-content: left;
            flex-direction: row;
            flex-wrap: wrap;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            align-content: center;
            vertical-align: middle;
        }

        .carrierButton{
            background: url("../assets/image/left_arrow.png") no-repeat 1% 10%;
            background-size: 40px 40px;
            margin-top: 10px;
            margin-left: 20px;
            font-size: 20px;
            height: 120px;
            min-width: 400px;
            background-color: #d8edcf;
            border-radius: 5px;
            line-height: 120px;
            color: rgb(47,101,46);
        }
        .cfButton{
            background: url("../assets/image/right_arrow.png") no-repeat 1% 10%;
            background-size: 40px 40px;
            margin-top: 10px;
            font-size: 20px;
            height: 120px;
            width: 400px;
            margin-left: 20px;
            background-color: rgb(209,232,245);
            border-radius: 5px;
            line-height: 120px;
            color: rgb(39,93,124);
        }
    }

</style>
